import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { PressReleaseExploreContent } from './PressReleaseExplore';
import { PromptEvaluationListContent } from './PromptEvaluationList';
import EntityTypeManager from './EntityTypeManager';

type TabValue = 'explore' | 'evals' | 'entity-types';

export default function PromptWorkbench() {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = (searchParams.get('tab') as TabValue) || 'explore';

  const handleTabChange = (_: React.SyntheticEvent, newValue: TabValue) => {
    setSearchParams({ tab: newValue });
  };

  return (
    <Layout>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={currentTab} onChange={handleTabChange}>
          <Tab label="Explore" value="explore" />
          <Tab label="Evals" value="evals" />
          <Tab label="Entity Types" value="entity-types" />
        </Tabs>
      </Box>

      {currentTab === 'explore' && <PressReleaseExploreContent />}
      {currentTab === 'evals' && <PromptEvaluationListContent />}
      {currentTab === 'entity-types' && <EntityTypeManager />}
    </Layout>
  );
}
